import React, { ReactNode } from 'react'
import { Modal } from '@mui/material'

type ModalControllerProps = {
  isModalOpen: boolean
  onClose: () => void
  children: ReactNode
  widths?: string // use to override default width classes
}

export const ModalController = ({
  isModalOpen,
  onClose,
  children,
  widths = 'min-w-[340px] md:min-w-[700px]',
}: ModalControllerProps) => {
  return (
    <Modal open={isModalOpen} onClose={onClose}>
      <div className='flex flex-col md:flex-row md:place-items-center overflow-auto h-full p-5 justify-center'>
        <div
          className={`${widths} bg-white rounded-lg shadow-md md:max-h-[90vh] md:max-w-[915px] overflow-auto`}
        >
          {children}
        </div>
      </div>
    </Modal>
  )
}
